
<div class="login-page">
  <section class="hero">
    <div class="hero-brand">
      Cuida<span>Zap</span>
    </div>

    <div class="hero-copy">
      <span class="eyebrow">GESTÃO INTELIGENTE</span>

      <h1>
        Mais cuidado.<br>
        Mais conexão.
      </h1>

      <p>
        Uma plataforma simples para gerenciar assinaturas,
        parceiros e usuários com segurança.
      </p>
    </div>

    <div class="hero-bottom">
      CuidaZap • Backoffice
    </div>
  </section>

  <section class="form-side">
    <div class="login-card">
      <div class="mobile-brand">
        CuidaZap
      </div>

      <div class="welcome">
        BEM-VINDO DE VOLTA
      </div>

      <h2>Acesse sua conta</h2>

      <p class="subtitle">
        Entre com suas credenciais para continuar.
      </p>

      <form [formGroup]="form" (ngSubmit)="entrar()">
        <div class="form-group">
          <label for="email">E-mail</label>

          <input
            id="email"
            class="form-control"
            type="email"
            autocomplete="username"
            formControlName="email"
            placeholder="seu@email.com"
          >
        </div>

        <div class="form-group">
          <label for="senha">Senha</label>

          <input
            id="senha"
            class="form-control"
            type="password"
            autocomplete="current-password"
            formControlName="senha"
            placeholder="Digite sua senha"
          >
        </div>


        <button
          class="btn btn-primary submit"
          type="submit"
          [disabled]="form.invalid || loading()"
        >
          {{ loading() ? 'Entrando...' : 'Entrar na plataforma →' }}
        </button>
      </form>

      <div class="first-access">
        <span>É seu primeiro acesso?</span>

        <a routerLink="/primeiro-acesso" class="first-access-link">
          Clique aqui
        </a>
      </div>

      <div class="help">
        Acesso exclusivo para administradores e parceiros.
      </div>
    </div>
  </section>
</div>
